export default "__VITE_ASSET__fq$qgVgX__"